export default "__VITE_ASSET__CMwU2gbz__"